export const manageACallback = (response, callback) => {
  if(callback && typeof callback === 'function'){
    return callback(response);
  }
  return response;
}
